import React from "react";
import PropTypes from "prop-types";
import Row from "../../../common/Row";
import LeafletMap from "../../../common/map/LeafletMap";
import Button from "../../../common/Button";
import * as types from "../../../../constants/ComponentConstants";
import Marker from "../../../common/Marker";
import Link from "../../../common/Link";

const GemeenteOverzichtKaartForm = (props) => {
    const {
        models,
        gemeenteNaam,
        onCancelToonKaart
    } = props;

    const coordinaten = [];
    models.map(m => m.coordinaten.map(c => {
        let sportclubNames = "";
        const modelsWithSameCoordinates = models.filter(x => x.coordinaten.find(z => z.lengtegraad === c.lengtegraad && z.breedtegraad === c.breedtegraad));
        modelsWithSameCoordinates.map((mod) => sportclubNames = sportclubNames.concat(mod.naam + "\n"));
        coordinaten.push({ lat: c.breedtegraad, long: c.lengtegraad, color: types.COLOR_RED, title: sportclubNames + "\n" + c.adres });
    }));

    const linkClass = { "color": "#39b4e8", "font-weight": "bold", "paddingBottom": '2px', "paddingTop": '2px' };

    const legende = <div style={{ position: 'relative' }}>
        <Row><Marker onMap={false} size={0.75} color={types.COLOR_BLUE_DARK} />Verschillende organisaties op dezelfde locatie</Row>
        <Row><Marker onMap={false} size={0.75} color={types.COLOR_RED} />Sportclub</Row>
    </div>;
    const link = `https://www3.sport.vlaanderen/sportdb.iframemap.website/SportclubsOnMap.aspx?Gemeente=${gemeenteNaam}&hoogte=500px&breedte=600px&url_bronsite=${gemeenteNaam}`;

    return (
        <div className="o-col-12">
            <Row>
                <LeafletMap markers={coordinaten} legende={legende} />
            </Row>
            &nbsp;
            <Row>
                <p>
                    <b>Uitleg</b>
                    <br />
                    Wil je een vergelijkbaar kaartje op je eigen website plaatsen of wil je het als link in je e-mailhandtekening opnemen?
                    <br /><br />
                    Dat kan zeer eenvoudig via onderstaande links.
                    <br /><br />
                    De hoogte of de breedte van de kaart kan je zelf aanpassen.<br />
                    De andere attributen dien je ongewijzigd te laten omdat anders de kaart niet werkt.
                    <br /><br />
                    Vragen hierover kan je stellen via <a style={linkClass} href="mailto:sportdb@sport.vlaanderen">sportdb@sport.vlaanderen</a>.
                    <br /><br />
                    <b>Code:</b><br />
                    <b>IFrame:</b><br />
&lt;iframe id="MySportclubIframe" src="https://www3.sport.vlaanderen/sportdb.iframemap.website/SportclubsOnMap.aspx?Gemeente={gemeenteNaam}&hoogte=500px&breedte=600px&url_bronsite={gemeenteNaam}"&gt; &lt;/iframe&gt;
<br /><br />
                    <b>Link:</b><br />
                    <a target="_blank" style={linkClass} href={link}>{link}</a>
                </p>
            </Row>
            &nbsp;
            <Row>
                <Button text="Keer terug" onClick={onCancelToonKaart} small />
            </Row>
        </div>
    );
};

GemeenteOverzichtKaartForm.propTypes = {
    models: PropTypes.array,
    gemeenteNaam: PropTypes.string,
    onCancelToonKaart: PropTypes.func
};

export default GemeenteOverzichtKaartForm;